import Workplace from "./workplace";
import Company from "./company";


class User {
    id = null;
    fullName = null;
    firstName = null;
    lastName = null;
    email = null;
    isAuthenticated = false;
    isStaff = false;
    isSuperuser = false;
    company = null;
    workplaces = [];
    managedWorkplaces = [];
    permissions = new Set();
    privateSectionLocked = true;

    constructor(props = null) {
        if (props) {
            Object.assign(this, props);
            this.company = new Company(props.company)

            let workplaces = []
            let managedWorkplaces = []

            if (props.workplaces) {
                for (const workplace of props.workplaces) {
                    workplaces.push(new Workplace(workplace))
                }
                this.workplaces = workplaces;
            }

            if (props.managedWorkplaces) {
                for (const workplace of props.managedWorkplaces) {
                    managedWorkplaces.push(new Workplace(workplace))
                }
                this.managedWorkplaces = managedWorkplaces;
            }

            if (props.permissions) {
                this.permissions = new Set(props.permissions)
            }
        }
    }

    workplaceIn(workplaceTypes) {
        for (const workplace of this.workplaces) {
            if (workplaceTypes.includes(workplace.type)) {
                return true
            }
        }
        return false
    }

    hasSameWorkplaceAs(user) {
        let workplacesOverlap = false
        // Extract only workplace id from all user's workplaces
        const workplaces = this.workplaces.reduce((workplaces, workplace) => {
            workplaces.push(workplace.id)
            return workplaces
        }, [])

        // Check if any workplace overlaps
        user.workplaces.forEach(workplace => {
            if (workplaces.includes(parseInt(workplace.id))) {
                workplacesOverlap = true
            }
        })
        return workplacesOverlap
    }

    isManager(workplaceId) {
        for (const workplace of this.managedWorkplaces) {
            if (workplaceId === workplace.id) {
                return true
            }
        }
        return false
    }

    hasPermission(permission) {
        return this.permissions.has(permission)
    }

    hasAnyOfPermissions(permissions){
        return permissions.some(item => this.permissions.has(item));
    }
}

export const currentUser = new User(window['EODSUN_USER']);
